
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import ChatController from '../../../controllers/Chat';

const msgHandler = msgable => {   // REVIEW REDUNDANTE en todos los formularios, SocialLogin y ChatSidebar
  if( msgable.msg) alert( msgable.msg);
}

const errorHandler = async executable => {
  try {
    await executable();
  } catch( error) {
    msgHandler( error);
  }
}

const ChangePassword = props => {

  const inputs = {
    password: null, password2: null,
  }

  const onSend = async () => {
    if( inputs.password.value !== inputs.password2.value) {
      alert( 'Los campos de password no coinciden, reviselos.');
    } else {
      await errorHandler( async () => {
        const response = await ChatController.changePassword( props.chatConfiguration, props.state.sessionToken, inputs.password.value);
        msgHandler( response);
        if( props.clearForm) props.clearForm();
      });
    }
  };

  const enterHandler = async event => {
    if( event.key === 'Enter') await onSend();
  };

  useEffect( _ => {
    ReactDOM.findDOMNode( inputs.password).focus();
  }, [ inputs.password ]);

  return (
    <div className={''}>
      <div className={'tab'}>
        <label>CHANGE PASSWORD</label>
      </div>
      <br />
      <label> New password: </label>
      <input className={'form-control'} ref={ ref => inputs.password = ref } type='password' onKeyDown={ enterHandler }></input>
      <label> Repeat password: </label>
      <input className={'form-control'} ref={ ref => inputs.password2 = ref } type='password' onKeyDown={ enterHandler }></input>
      <div className={'btn-group pull-right'}>
        <br />
        <button className={'cancel'} onClick={ props.clearForm }> Cancel </button>
        <button className={'submit'} onClick={ onSend }> Send </button>
      </div>
    </div>
  );
};

export default ChangePassword;
